/**
 * Buraxılış sual siyahısı üçün utils – tək mənbə buraxilisConfig.
 */

import {
  BuraxilisBlankContext,
  Grade11BlankScheme,
  getBuraxilisSubjectsForGrade,
} from '../constants/buraxilisConfig';

/** Normalize fənn adı BURAXILIS_QUESTIONS subject adlarına uyğunlaşdırmaq üçün */
function normalizeFennForConfig(fenn: string): string {
  const t = fenn.trim();
  if (!t) return t;
  if (t === 'İngilis' || t.toLowerCase() === 'ingilis') return 'İngilis dili';
  if (t === 'Rus' || t.toLowerCase() === 'rus') return 'Rus dili';
  if (t === 'Alman' || t.toLowerCase() === 'alman') return 'Alman dili';
  if (t === 'Fransız' || t.toLowerCase() === 'fransız' || t.toLowerCase() === 'fransiz') return 'Fransız dili';
  return t;
}

/**
 * Buraxılış üçün verilmiş sinif və fənnə görə sual siyahısı qaytarır.
 * Grade 11: ctx (exam createdAt / grade11BlankScheme) ilə köhnə vs yeni blank seçilir.
 */
export function getBuraxilisQuestionsForFenn(
  grade: number,
  fenn: string,
  ctx?: BuraxilisBlankContext | Grade11BlankScheme | null
): string[] {
  const config = getBuraxilisSubjectsForGrade(grade, ctx);
  if (!config.length) return [];

  const normalizedFenn = normalizeFennForConfig(fenn);
  const subject = config.find((s) => s.subject === normalizedFenn);
  return subject ? [...subject.questions] : [];
}
